import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { BackendProvider } from "../backend/BackendProvider";
import { AuthSessionProvider } from "../auth/AuthSessionProvider";
import { queryClient } from "./queryClient";
import { router } from "./router";

if (import.meta.env.DEV) (window as Window & { __cftodoQueryClient?: typeof queryClient }).__cftodoQueryClient = queryClient;

export function App() {
  return (
    <BackendProvider>
      <QueryClientProvider client={queryClient}>
        <AuthSessionProvider>
          <RouterProvider router={router} />
        </AuthSessionProvider>
      </QueryClientProvider>
    </BackendProvider>
  );
}
